module.exports = __webpack_public_path__ + "static/img/2_1.c3e5352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/2_1.png
// module id = JO7E
// module chunks = 44